import React from 'react'
import LazyLoad from 'react-lazyload'
import './index.scss'

const DetailProcess = () => (
  <>
    <LazyLoad offset={100} height={334}>
      <div className="r-detail-process" data-exposure="car-detail_process_display">
        <h2 className="r-detail-process__title">买车流程</h2>
        <ul className="r-detail-process__main clearfix">
          <li className="item">
            <i className="iconfont icon-yuyue" />
            <h4>预约看车</h4>
            <p>一键预约，好车不错过</p>
            <i className="iconfont icon-jiantou1" />
          </li>
          <li className="item">
            <i className="iconfont icon-jiaotan" />
            <h4>专人带看</h4>
            <p>一对一服务，及时答疑解惑</p>
            <i className="iconfont icon-jiantou1" />
          </li>
          <li className="item">
            <i className="iconfont icon-hetong" />
            <h4>交易过户</h4>
            <p>现场提车，安心过户</p>
            <i className="iconfont icon-jiantou1" />
          </li>
          <li className="item">
            <i className="iconfont icon-xin" />
            <h4>安享质保</h4>
            <p>服务完善，售后更省心</p>
          </li>
        </ul>
      </div>
    </LazyLoad>
  </>
)

export default DetailProcess
